module.exports = "/assets/data/3fd00ceba98f883530ce29c2392639c0-LD8.data.json";